// export const IMG_PATH = 'http://localhost:8888/static/';

// export const IMG_PATH = 'http://159.65.3.155:8888/static/';
// export const IMG_PATH = 'https://api-dev.siammusicmembers.com/static/';


export const IMG_PATH = 'https://api.siammusicmembers.com/static/';
